/**
 * @generated SignedSource<<9d67c1aa9764d83017bd87d2653abe3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      }
    ],
    "concreteType": "CityResponseType",
    "kind": "LinkedField",
    "name": "source",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "CMCityname",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "CMCityid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PickupDropLocations",
        "kind": "LinkedField",
        "name": "pickupDropPoints",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cityId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetSourceListingQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetSourceListingQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "22ca2191c0731391090e77f94458bd1f",
    "id": null,
    "metadata": {},
    "name": "GetSourceListingQuery",
    "operationKind": "query",
    "text": "query GetSourceListingQuery(\n  $searchTerm: String\n) {\n  source(searchTerm: $searchTerm) {\n    CMCityname\n    CMCityid\n    pickupDropPoints {\n      cityId\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "73b19c3c548b44a363afd4a7ede5b713";

module.exports = node;
